export const AU_TAX_REGIME_ID = 1;
export const NZ_TAX_REGIME_ID = 3;
export const CA_TAX_REGIME_ID = 5;
export const GB_TAX_REGIME_ID = 9;

export class RegimeApiModel {
  id: number;
  name: string;
  isAccounts: boolean;
  hasPools: boolean;
}
